import { IAuth, LoginResponse } from "@/interfaces/IAuth";
import { IUser } from "@/interfaces/IUser";

/**
 * Transforma la respuesta de login de la API v2 al formato interno de la aplicación
 * @param loginResponse - Respuesta de login de la API v2
 * @returns Objeto IAuth en formato interno
 */
export const transformLoginResponse = (loginResponse: LoginResponse): IAuth => {
  const { auth_data } = loginResponse.data;

  // La respuesta de la API puede tener un objeto `user` anidado dentro de `auth_user`.
  // Esta línea extrae de forma segura los datos reales del usuario, ya sea que estén anidados o no.
  const userPayload = (auth_data.auth_user as any).user || auth_data.auth_user;

  // Crear el usuario con groups_detail para compatibilidad
  const user: IUser = {
    ...userPayload,
    groups_detail: Array.isArray(userPayload.groups)
      ? (userPayload.groups as any[]) // En v2 ya viene como array de objetos
      : [], // Fallback si no es array
  };

  return {
    tokens: auth_data.auth_token,
    user: user,
  };
};

/**
 * Verifica si la respuesta de la API fue exitosa
 * @param response - Respuesta de la API v2
 * @returns boolean indicando si fue exitosa
 */
export const isApiResponseSuccess = (response: { status: string; code: number }): boolean => {
  return response.status === "success" && response.code === 200;
};
